const MONTHS_RU = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
];

/**
 * Formats ISO date string to Russian format.
 * Example: "2026-04-05T12:00:00Z" -> "5 апреля 2026"
 */
export function formatDate(isoDate: string): string {
  const date = new Date(isoDate);
  const day = date.getDate();
  const month = MONTHS_RU[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
}

/**
 * Formats ISO date string to short Russian format.
 * Example: "2026-04-05T12:00:00Z" -> "05.04.2026"
 */
export function formatDateShort(isoDate: string): string {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}

/**
 * Formats ISO date string to short Russian date with time.
 * Example: "2026-10-11T14:02:00Z" -> "11.10.2026 14:02" (local time)
 */
export function formatDateTimeShort(isoDate: string): string {
  const date = new Date(isoDate);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${formatDateShort(isoDate)} ${hours}:${minutes}`;
}
